import $ from 'jquery';
import * as tooltip from './tooltip';
import * as Plottable from 'plottable';
import moment from 'moment';
import _forEach from 'lodash/forEach';
import _values from 'lodash/values';

import { measurementHasEnded, getRealDateBounds } from './date';

/* Helpers */

/* NOTE: Required for IE 11 */
if (typeof Object.assign !== 'function') {
  Object.assign = function(target, ...sources) {
    sources.forEach((source) => {
      Object.keys(source).forEach((key) => {
        target[key] = source[key];
      });
    });

    return target;
  };
}

/* End: helpers */

let params;

export const initializePrecipitationChart = function() {
  const PARAMETER = 'prate';
  const $CONTAINER = $(`.${PARAMETER}-chart`);

  if ($CONTAINER.length === 0) {
    return;
  }

  let plot;
  const { lat, lng } = $CONTAINER.data();

  const $TOOLTIP = tooltip.create('prate-tooltip');

  const POINTER = new Plottable.Interactions.Pointer();
  POINTER.onPointerMove((point) => {
    const CLOSEST = plot.entityNearest(point);

    if (CLOSEST) {
      $TOOLTIP.html(tooltip.markup(CLOSEST.datum.x, CLOSEST.datum.y));

      // moves the tooltip to the middle, does not work perfectly
      // if the map is "zoomed out" (60 days, total) but is better than nothing
      CLOSEST.bounds.x = CLOSEST.bounds.x - (CLOSEST.bounds.width / 2);

      $TOOLTIP.place($CONTAINER.children().get(0), CLOSEST.bounds);

      $TOOLTIP.show();
    }
  });

  POINTER.onPointerExit(() => $TOOLTIP.hide());

  $('body').on('chart-switcher-update', (event, bounds) => {
    if (plot) {
      plot.destroy();
      POINTER.detachFrom(plot);
      $CONTAINER.children().empty();
    }

    const URI = `https://grids.meteotest.ch/query_timeseries?${$.param({
      format: 'json',
      lat,
      lon: lng,
      name: 'radar_archive',
      param: PARAMETER,
      start: bounds.start.startOf('day').format('YYYY-MM-DD HH:mm'),
      end: bounds.end.endOf('day').format('YYYY-MM-DD HH:mm'),
    })}`;

    $.getJSON(URI)
      .done((data) => {
        const parsed = {};
        _forEach(data.location1, (datum, date) => {
          // was originally hour(12) to use the middle of the day, but there is an offset,
          // which is corrected by choosing hour(10)
          const WHEN = moment.utc(date, 'YYYY-MM-DD HH:mm:ss').hour(10);
          const KEY = WHEN.format('YYYY-MM-DD');
          const VALUE = parseFloat(datum[PARAMETER]);
          const CURRENT = parsed[KEY] || {
            x: WHEN,
            y: 0,
          };
          CURRENT.y += VALUE;
          parsed[KEY] = CURRENT;
        });

        _forEach(
          parsed,
          (precipitationRatePerHourEvery5mins, dateStr, data) => {
            data[dateStr].y = precipitationRatePerHourEvery5mins.y / 12;
          }
        );

        // the insertion of empty data leaves the list unordered, that's why we need to sort it
        // eslint-disable-next-line no-confusing-arrow
        const VALUES = _values(parsed).sort((a, b) => a.x.isBefore(b.x) ? -1 : 1);

        const X_SCALE = new Plottable.Scales.Time().domain([
          // this .startOf(day) makes the whole first day visible instead of only half of it
          VALUES[0].x.startOf('day'),
          VALUES[VALUES.length - 1].x,
        ]);

        const Y_SCALE = new Plottable.Scales.Linear();

        const X_AXIS = new Plottable.Axes.Time(X_SCALE, 'bottom');
        const Y_AXIS = new Plottable.Axes.Numeric(Y_SCALE, 'left');

        plot = new Plottable.Plots.Bar()
          .addDataset(new Plottable.Dataset(VALUES))
          .x(data => data.x, X_SCALE)
          .y(data => data.y, Y_SCALE)
          .attr('fill', '#1e4ac7');

        const GRID = new Plottable.Components.Gridlines(null, Y_SCALE);

        const GROUP = new Plottable.Components.Group([plot, GRID]);

        const CHART = new Plottable.Components.Table([
          [Y_AXIS, GROUP],
          [null, X_AXIS],
        ]);

        // adjust the margin of the table to fit the other tables depending on tab size
        const adjustMargin = () => {
          if ($('#tab1').width() < 1300) {
            $('.prate-chart').css('margin', '15px');
            $('.prate-chart').css('margin', '15px');
          } else {
            $('.prate-chart').css('margin', 'auto');
            $('.prate-chart').css('margin', 'auto');
          }
        };

        CHART.renderTo($CONTAINER.children().get(0));

        $('.plottable').css('width', '100%');
        $('.plottable').css('height', '200px');

        $(document).ready(() => {
          adjustMargin();
          CHART.redraw();
        });

        $(window).on('resize', () => {
          adjustMargin();
          CHART.redraw();
        });

        POINTER.attachTo(plot);
      })
      .fail(console.error); // eslint-disable-line no-console
  });

  const MEASUREMENT_HAS_ENDED = measurementHasEnded(params.end);

  params = getRealDateBounds(params);

  $CONTAINER.trigger('chart-switcher-update', {
    start: MEASUREMENT_HAS_ENDED
      ? params.start
      : moment().startOf('day')
        .subtract(30, 'days'),
    end: MEASUREMENT_HAS_ENDED ? params.end : moment(),
  });
};

export const initializeChartSwitcher = function() {
  const $SWITCHER = $('#chart-switcher');
  const $FRAMES = $('.chart-frame');

  if ($SWITCHER.length === 0 || $FRAMES.length === 0) {
    return;
  }

  params = $SWITCHER.data();
  const MEASUREMENT_END = params.end;

  const $BUTTONS = $SWITCHER.find('button');
  $BUTTONS.each((index) => {
    const $BUTTON = $BUTTONS.eq(index);
    $BUTTON.on('click', () => {
      const PARAMS_LOCAL = Object.assign({}, params);

      Object.assign(
        PARAMS_LOCAL,
        getRealDateBounds({
          start: PARAMS_LOCAL.start,
          end: MEASUREMENT_END,
          daysAgo: $BUTTON.data('days-ago'),
        })
      );

      $('body').trigger('chart-switcher-update', PARAMS_LOCAL);

      $BUTTONS.removeClass('current');
      $BUTTON.addClass('current');

      ['start', 'end'].forEach((key) => {
        PARAMS_LOCAL[key] = PARAMS_LOCAL[key].format('YYYY-MM-DD');
      });

      $FRAMES.each((index) => {
        /* FIXME: Only modify existing src query-part */
        const $FRAME = $FRAMES.eq(index);
        $FRAME.attr('src', `${$FRAME.data().api}?${$.param(PARAMS_LOCAL)}`);
      });
    });
  });
};



// WEBPACK FOOTER //
// ./theme_src/js/charts.js